export const GEOLOCATION_EXPIRATION_TIME_MS = 24 * 60 * 60 * 1000; // 24 hours